import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import { useLocation, useNavigate } from "react-router-dom";

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
    color: "#e7e7e9",
    padding: "32px 16px 48px",
    fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
    boxSizing: "border-box",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  card: {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.07)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.32)",
    borderRadius: "18px",
    padding: "18px 16px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "8px",
  },
  titleWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  badge: {
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#130903",
    padding: "6px 12px",
    borderRadius: "999px",
    fontWeight: 800,
    fontSize: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    display: "inline-block",
  },
  title: {
    margin: 0,
    fontSize: "24px",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: "-0.02em",
  },
  helper: {
    margin: 0,
    color: "#cbd5e1",
    fontSize: "13px",
    lineHeight: 1.5,
  },
  actionsRow: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    alignItems: "center",
  },
  ghostBtn: {
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.06)",
    color: "#f8fafc",
    fontWeight: 700,
    cursor: "pointer",
  },
  searchInput: {
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.05)",
    color: "#f8fafc",
    minWidth: "220px",
  },
  tableWrap: {
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    marginTop: "12px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.07)",
    width: "100%",
  },
  table: {
    width: "100%",
    minWidth: "960px",
    borderCollapse: "collapse",
    color: "#e7e7e9",
    fontSize: "14px",
  },
  th: {
    background: "rgba(255,255,255,0.06)",
    padding: "10px",
    textAlign: "center",
    fontWeight: 800,
    borderBottom: "1px solid rgba(255,255,255,0.08)",
  },
  td: {
    padding: "10px",
    textAlign: "center",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
  },
  uidSub: {
    display: "block",
    marginTop: "4px",
    fontSize: "12px",
    color: "#94a3b8",
    fontWeight: 500,
  },
};

export default function AdminPage() {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // 검색어 상태
  const [cookies] = useCookies(['uuid']);

  // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
  const[email,setEmail] = useState('');
  const[pw,setPW] = useState('');
  const[super_user,setSuperuser] = useState('');

  const location = useLocation();
  const navigate = useNavigate();

  // const[margin,setMargin] = useState('');

  // ✅ 권한 확인
  const fetchUserInfo = (uuid) => {
    fetch(`/SetPage/admin_user?uuid=${uuid}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("서버 응답 실패");
        }
        return response.json();
      })
      .then((data) => {
        const user = data[0];
        if (user && (user.super_user === 1 || user.super_user === "1")) {
          setEmail(user.email);
          setPW(user.pw);
          setSuperuser(user.super_user);
        } else {
          alert("접근 권한이 없습니다.");
          navigate("/SelectPage", { replace: true });
        }
      })
      .catch((error) => {
        console.error("fetchUserInfo 오류:", error);
        alert("로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.");
        navigate("/LoginAts", { replace: true });
      });
  };

  // ✅ uuid / 경로 변경될 때마다 권한 체크
  useEffect(() => {
    if (!cookies.uuid) {
      alert("로그인 정보가 존재하지 않습니다. 관리자 로그인 페이지로 이동합니다.");
      navigate("/LoginAts", { replace: true });
    } else {
      fetchUserInfo(cookies.uuid);
    }
  }, [cookies.uuid, location.pathname]);

  // ✅ 사용자 목록 가져오기
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`/admin/users`);
        if (!response.ok) {
          throw new Error("서버 응답 실패");
        }
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Waiting List 가져오기 오류:", error);
        alert(error);
      }
    };

    fetchUsers();
  }, []);

  // ✅ users 상태 변경 감지
  useEffect(() => {
    console.log("Users 상태값이 변경되었습니다:", users);
  }, [users]);


  const handleApprove = async (uid, nickname) => {
    const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님을 사용승인 처리하시겠습니까?`);

    if (confirmed) {
        try {
          const response = await fetch('/admin/approve', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ uid }),
          });
          if (!response.ok) {
            throw new Error('Failed to approve user');
          }
          const data = await response.json();
          // 해당 사용자의 정보만을 업데이트합니다.
          setUsers(prevUsers => prevUsers.map(user => {
            if (user.uid === uid) {
              return { ...user, login_possible: data[0].login_possible };
            }
            return user;
          }));
            alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 사용승인이 완료 되었습니다.`);
            // 로그인 가능한 경우에 필요한 작업 수행
         } catch (error) {
          console.error('Error approving user:', error);
        }
      };
  };

  const handleRevoke = async (uid,nickname) => {
    const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님을 사용해제 처리하시겠습니까?`);

    if (confirmed) {
      try {
        const response = await fetch('/admin/revoke', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ uid }),
        });
        if (!response.ok) {
          throw new Error('Failed to revoke user');
        }

        const data = await response.json();
        // 해당 사용자의 정보만을 업데이트합니다.
        if (data.login_possible === 'revoke') {
          setUsers(prevUsers => prevUsers.filter(user => user.uid !== uid));
        } 
          alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 사용 해제가 완료 되었습니다.`);
          return users;
        } catch (error) {
        console.error('Error revoking user:', error);
      }
    };
  };

  ////////////////// Track 승인여부 //////////////////
  const handle_Track_Approve = async (uid, nickname) => {
    const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 track version 프로그램 사용 승인하시겠습니까?`);

    if (confirmed) {
        try {
          const response = await fetch('/admin/approve_track', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ uid }),
          });
          if (!response.ok) {
            throw new Error('Failed to approve track_program');
          }
          const data = await response.json();
          // 해당 사용자의 정보만을 업데이트합니다.
          setUsers(prevUsers => prevUsers.map(user => {
            if (user.uid === uid) {
              return { ...user, track_possible: data[0].track_possible };
            }
            return user;
          }));
            alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 track version 프로그램 사용승인이 완료 되었습니다.`);
            // 로그인 가능한 경우에 필요한 작업 수행
         } catch (error) {
          console.error('Error approving user:', error);
        }
      };
  };

  const handle_track_Revoke = async (uid,nickname) => {
    const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 track version 프로그램 사용 해제하시겠습니까?`);

    if (confirmed) {
      try {
        const response = await fetch('/admin/revoke_track', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ uid }),
        });
        if (!response.ok) {
          throw new Error('Failed to revoke user');
        }

        const data = await response.json();
        // 해당 사용자의 정보만을 업데이트합니다.
        setUsers(prevUsers => prevUsers.map(user => {
          if (user.uid === uid) {
            return { ...user, track_possible: data[0].track_possible };
          }
          return user;
        }));
        alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 track version 프로그램 사용 해제가 완료 되었습니다.`);
        } catch (error) {
        console.error('Error revoking user:', error);
      }
    };
  };
  
    ////////////////// 이메일 변경 ////////////////////
  const handleChangeEmail = async (uid, nickname) => {
      const newEmail = window.prompt(`UID : ${uid} / NICKNAME : ${nickname} 님의 새 이메일을 입력하세요:`);
    
      if (!newEmail) return; // 사용자가 취소를 누르면 아무 작업도 하지 않음
    
      const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 e-mail을 "${newEmail}"(으)로 변경하시겠습니까?`);
    
      if (confirmed) {
        try {
          const response = await fetch('/admin/change_email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uid, email: newEmail }), // 새 이메일 전송
          });
    
          if (!response.ok) throw new Error('Failed to change email');
    
          const data = await response.json();
    
          setUsers(prevUsers => prevUsers.map(user => 
            user.uid === uid ? { ...user, email: data[0].email } : user
          ));
    
          alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 e-mail 정보가 변경 완료 되었습니다.`);
        } catch (error) {
          console.error('Error changing email:', error);
        }
      }
    };
    
    ////////////////// 비밀번호 변경 ////////////////////
  const handleChangePassword = async (uid, nickname) => {
      const newPassword = window.prompt(`UID : ${uid} / NICKNAME : ${nickname} 님의 새 비밀번호를 입력하세요:`);
    
      if (!newPassword) return; // 사용자가 취소를 누르면 아무 작업도 하지 않음
    
      const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 비밀번호를 "${newPassword}"(으)로 변경하시겠습니까?`);
    
      if (confirmed) {
        try {
          const response = await fetch('/admin/change_password', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uid, pw: newPassword }), // 새 이메일 전송
          });
    
          if (!response.ok) throw new Error('Failed to change password');
    
          const data = await response.json();
    
          setUsers(prevUsers => prevUsers.map(user => 
            user.uid === uid ? { ...user, pw: data[0].pw } : user
          ));
    
          alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 password 정보가 변경 완료 되었습니다.`);
        } catch (error) {
          console.error('Error changing email:', error);
        }
      }
    };
  
  ////////////////// 닉네임 변경 ////////////////////
  const handleChangeNickname = async (uid, nickname) => {
    const newNickname = window.prompt(`UID : ${uid} / NICKNAME : ${nickname} 님의 새 닉네임을 입력하세요:`);
  
    if (!newNickname) return; // 사용자가 취소를 누르면 아무 작업도 하지 않음
  
    const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 닉네임을 "${newNickname}"(으)로 변경하시겠습니까?`);
  
    if (confirmed) {
      try {
        const response = await fetch('/admin/change_nickname', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ uid, nickname: newNickname }), // 새 Nickname 전송
        });
  
        if (!response.ok) throw new Error('Failed to change nickname');
  
        const data = await response.json();
  
        setUsers(prevUsers => prevUsers.map(user => 
          user.uid === uid ? { ...user, nickname: data[0].nickname } : user
        ));
  
        alert(`UID : ${uid} 님의 NICKNAME 정보가 변경 완료 되었습니다.`);
      } catch (error) {
        console.error('Error changing nickname:', error);
      }
    }
  };

  // 승인 및 슈퍼승인 여부에 따른 스타일을 정의하는 함수
const getApprovalStyle = (loginPossible) => {
  let style = {
    color: loginPossible === "1" || loginPossible === 1 ? "red" : "black", 
  };
  style.fontWeight = "bold";

  return style;
};

// 승인 및 슈퍼승인 여부에 따른 텍스트를 생성하는 함수
const getApprovalText = (loginPossible, track_possible) => {
  let text = loginPossible === "1" || loginPossible === 1 ? "승인" : "승인대기중";

  if (track_possible === "1" || track_possible === 1) {
    text += " / TRACK";
  }

  return text;
};


// 등급 표시 스타일: 주황색 + bold
const getGradeStyle = () => ({
  color: "lightblue",
});

// 사용기한 표시 스타일: 만료 시 빨강, 남았으면 초록
const getExperiodStyle = (exPeriod) => {
  if (!exPeriod) return {};

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const parsed = new Date(exPeriod);
  if (Number.isNaN(parsed.getTime())) return {};

  const isExpired = parsed < today;

  return {
    color: isExpired ? "red" : "lightgreen",
  };
};

  ////////////////// 등급 변경 ////////////////////
const handleChangeGrade = async (uid, nickname) => {
  // ⭐ 등급 선택을 위해 반드시 await 필요
  const newGrade = await promptForGrade();

  if (!newGrade) return; // 사용자가 취소하거나 잘못 입력한 경우 종료

  const confirmed = window.confirm(
    `UID : ${uid} / NICKNAME : ${nickname} 님의 등급을 "${newGrade}"(으)로 변경하시겠습니까?`
  );

  if (confirmed) {
    try {
      const response = await fetch('/admin/change_grade', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid, grade: newGrade }),
      });

      if (!response.ok) throw new Error('Failed to change grade');

      const data = await response.json();

      setUsers(prevUsers =>
        prevUsers.map(user =>
          user.uid === uid ? { ...user, grade: data[0].grade } : user
        )
      );

      alert(`UID : ${uid} 님의 등급 정보가 변경 완료 되었습니다.`);
    } catch (error) {
      console.error('Error changing grade:', error);
    }
  }
};

  const promptForGrade = () => {
  return new Promise((resolve) => {
    const grade = window.prompt(
      "등급을 입력하세요:\n\n1) silver\n2) gold\n\n입력 예: silver"
    );

    const allowed = ["silver", "gold"];

    if (allowed.includes(grade)) {
      resolve(grade);
    } else {
      alert("잘못된 등급입니다. silver / gold 중에서 선택하세요.");
      resolve(null);
    }
  });
};

  ////////////////// 사용기한 변경 ////////////////////
  const handleChangeExperiod = async (uid, nickname) => {
    // 날짜 선택을 위한 상태 초기화
  const newExperiod = promptForDate();

  if (!newExperiod) return; // 사용자가 취소를 누르면 아무 작업도 하지 않음

  const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 사용기한을 "${newExperiod}"(으)로 변경하시겠습니까?`);

  if (confirmed) {
    try {
      const response = await fetch('/admin/change_experiod', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid, ex_period: newExperiod }), // 새 유효기간 전송
      });

      if (!response.ok) throw new Error('Failed to change ex_period');

      const data = await response.json();

      setUsers(prevUsers => prevUsers.map(user => 
        user.uid === uid ? { ...user, ex_period: data[0].ex_period } : user
      ));

      alert(`UID : ${uid} 님의 사용기한 정보가 변경 완료 되었습니다.`);
    } catch (error) {
      console.error('Error changing ex_period:', error);
    }
    }
  };

  // 날짜를 선택하는 prompt UI
  const promptForDate = () => {
    const userInput = prompt("새 유효기간을 YYYY-MM-DD 형식으로 입력하세요:");

    // 날짜가 올바른 형식인지 확인 (정규 표현식을 사용하여 체크)
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;

    if (datePattern.test(userInput)) {
      return userInput; // 유효한 날짜 형식
    } else {
      alert("날짜 형식이 잘못되었습니다. YYYY-MM-DD 형식으로 입력하세요.");
      return null; // 잘못된 형식 입력 시 null 반환
    }
  };

//로그아웃
const handleLogout = () => {
  const uuid = cookies.uuid; // cookies에서 uuid를 얻어옴
  if (!uuid) {
    alert('로그인 정보가 존재하지 않습니다.');
    return;
  }
  // 로그아웃 요청을 서버로 보냅니다.
  fetch('/logout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ userId: uuid })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('로그아웃 요청 실패');
    }
    console.log('로그아웃 성공');
    alert('Logout is successful.');
    window.location.href = '/';
  })
  .catch(error => {
    console.error('로그아웃 요청 중 오류 발생:', error);
  });
// UUID를 서버로 보내는 예시 코드

}

// 검색어가 포함된 사용자만 필터링
const filteredUsers = users.filter(
  (user) =>
    user.uid.toString().includes(searchQuery) ||
    user.nickname.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (user.email || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
    (user.mobile || "").includes(searchQuery)
);

const handleSearchChange = (e) => {
  setSearchQuery(e.target.value);
};

const handleAdManage = () => {
  navigate("/AdManage");
};

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.headerRow}>
            <div style={styles.titleWrap}>
              <span style={styles.badge}>Speed BOT</span>
              <h2 style={styles.title}>Admin User Management</h2>
              <p style={styles.helper}>승인, track 승인, 계정 정보 변경을 관리합니다.</p>
            </div>
            <div style={styles.actionsRow}>
              <button style={styles.ghostBtn} onClick={handleLogout}>Logout</button>
              <button style={styles.ghostBtn} onClick={handleAdManage}>광고 관리</button>
              <input
                type="text"
                placeholder="UID, 닉네임, 이메일, 전화번호 검색"
                value={searchQuery}
                onChange={handleSearchChange}
                style={styles.searchInput}
              />
            </div>
          </div>

          <div style={styles.tableWrap}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>#</th>
                  <th style={styles.th}>UID</th>
                  <th style={styles.th}>Nickname</th>
                  <th style={styles.th}>전화번호</th>
                  <th style={styles.th}>등급</th>
                  <th style={styles.th}>사용기한</th>
                  <th style={styles.th}>승인여부</th>
                  <th style={styles.th}>Action</th>
                  <th style={styles.th}>track 사용승인</th>
                  <th style={styles.th}>계정정보변경</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.slice().reverse().map((user, index) => (
                <tr key={user.uid}>
                  <td style={styles.td}>{index + 1}</td>
                  <td style={styles.td}>
                    {user.uid}
                    {user.email && (
                      <span style={styles.uidSub}>({user.email})</span>
                    )}
                  </td>
                  <td style={styles.td}>{user.nickname}</td>
                  <td style={styles.td}>{user.mobile || "-"}</td>
                  <td style={{ ...styles.td, ...getGradeStyle() }}>{user.grade}</td>
                  <td style={{ ...styles.td, ...getExperiodStyle(user.ex_period) }}>{user.ex_period}</td>
                  <td style={{ ...styles.td, ...getApprovalStyle(user.login_possible) }}>{getApprovalText(user.login_possible, user.track_possible)}</td>
                  <td style={styles.td}>
                    <div className="button-group">
                    <button className="action-button large-button approve-button" onClick={() => handleApprove(user.uid,user.nickname)}>승인하기</button>
                    <button className="action-button large-button delete-button" disabled={(super_user === '0' || super_user === 0)} onClick={() => handleRevoke(user.uid,user.nickname)}>계정삭제</button>
                    </div>
                  </td>
                  <td style={styles.td}>
                  <div className="button-group">
                    <button className="action-button large-button approve-button" disabled={(super_user === '0' || super_user === 0)} onClick={() => handle_Track_Approve(user.uid,user.nickname)}>track 사용승인</button>
                    <button className="action-button large-button revoke-button" disabled={(super_user === '0' || super_user === 0)} onClick={() => handle_track_Revoke(user.uid,user.nickname)}>track 승인해제</button>
                    </div>
                  </td>
                  <td style={styles.td}>
                  <div className="button-group">
                    <button className="action-button large-button reset-button" disabled={(super_user === '0' || super_user === 0)} onClick={() => handleChangeEmail(user.uid,user.nickname)}>이메일변경</button>
                    <button className="action-button large-button reset-button" disabled={(super_user === '0' || super_user === 0)} onClick={() => handleChangePassword(user.uid,user.nickname)}>비번변경</button>
                    <button className="action-button large-button reset-button" disabled={(super_user === '0' || super_user === 0)} onClick={() => handleChangeNickname(user.uid,user.nickname)}>닉네임변경</button>
                    <button className="action-button large-button reset-button" disabled={(super_user === '0' || super_user === 0)} onClick={() => handleChangeGrade(user.uid, user.nickname)}>등급변경</button>
                    <button className="action-button large-button reset-button" disabled={(super_user === '0' || super_user === 0)} onClick={() => handleChangeExperiod(user.uid,user.nickname)}>사용기한변경</button>
                    </div>
                  </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
